import * as React from 'react';
import { SVGProps } from 'react';

const IconMBUSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 1h8v2h-1.5l2.143 12H14v-4h7v4h2v2h-4v6h-2v-6H7v6H5v-6H1v-2h2.357L5.5 3H4V1zm15 14v-2h-3v2h3zM5.389 15 7.174 5h1.652l1.785 10H5.39z"
    />
  </svg>
);
export default IconMBUSizeM;
